module.exports = __webpack_public_path__ + "static/1-f00f12c2d5aef4ca8784dc05f0c9890b.jpg";